import React from 'react';
import { Link } from 'react-router-dom';
import './notFound.css';
import Navbar from './navbar';
import Footer from './footer';

const NotFound = () => {
  return (
    <>
      <Navbar />
      <div className="not-found-container">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="home-button">
          Return to Home
        </Link>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;